function CancelSubscriptionModal({
	isDarkMode,
	plan,
	accessUntil,
	seats,
	isCancelling,
	error,
	onConfirm,
	onClose,
}) {
	return (
		<div className="relative z-50">
			<div className="fixed inset-0 bg-gray-900/50 transition-opacity" />
			<div className="fixed inset-0 z-10 flex items-start justify-center pt-20 p-4">
				<div className="w-full max-w-md">
					<div
						className={`relative transform overflow-hidden rounded-lg px-6 pt-10 pb-6 text-left shadow-xl ${
							isDarkMode
								? 'bg-gray-800 outline outline-1 -outline-offset-1 outline-white/10'
								: 'bg-white'
						}`}
					>
						<div className="text-center">
							<svg
								className="mx-auto h-12 w-12 text-orange-400 mb-4"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
								/>
							</svg>
							<h3
								className={`text-lg font-semibold mb-3 ${
									isDarkMode ? 'text-white' : 'text-gray-900'
								}`}
							>
								Cancel your {plan} subscription?
							</h3>

							<div
								className={`text-sm mb-6 space-y-2 ${
									isDarkMode ? 'text-gray-300' : 'text-gray-500'
								}`}
							>
								<p>
									You keep full access until{' '}
									<span className="font-semibold">{accessUntil}</span>. You
									will not be charged again.
								</p>
								{seats > 1 && (
									<p className="text-orange-400">
										Your {seats} team members will lose access on that date.
									</p>
								)}
								<p>You can resume any time before then.</p>
							</div>

							{error && (
								<p className="text-sm text-red-500 mb-4">{error}</p>
							)}

							<div className="flex gap-3 justify-center">
								<button
									onClick={onClose}
									disabled={isCancelling}
									className={`rounded-md px-6 py-2 text-sm font-semibold disabled:opacity-50 ${
										isDarkMode
											? 'bg-gray-700 text-white hover:bg-gray-600'
											: 'bg-gray-100 text-gray-700 hover:bg-gray-200'
									}`}
								>
									Keep subscription
								</button>
								<button
									onClick={onConfirm}
									disabled={isCancelling}
									className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors disabled:opacity-50"
								>
									{isCancelling ? 'Cancelling...' : 'Yes, cancel'}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default CancelSubscriptionModal
